'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true,
});
exports.distance300ESpreadRadius =
  exports.distance300EOffsetY =
  exports.distance300EOffsetX =
  exports.distance300EColor =
  exports.distance300EBlurRadius =
  exports.distance300DSpreadRadius =
  exports.distance300DOffsetY =
  exports.distance300DOffsetX =
  exports.distance300DColor =
  exports.distance300DBlurRadius =
  exports.distance300CSpreadRadius =
  exports.distance300COffsetY =
  exports.distance300COffsetX =
  exports.distance300CColor =
  exports.distance300CBlurRadius =
  exports.distance300BSpreadRadius =
  exports.distance300BOffsetY =
  exports.distance300BOffsetX =
  exports.distance300BColor =
  exports.distance300BBlurRadius =
  exports.distance300ASpreadRadius =
  exports.distance300AOffsetY =
  exports.distance300AOffsetX =
  exports.distance300AColor =
  exports.distance300ABlurRadius =
  exports.distance200FSpreadRadius =
  exports.distance200FOffsetY =
  exports.distance200FOffsetX =
  exports.distance200FColor =
  exports.distance200FBlurRadius =
  exports.distance200ESpreadRadius =
  exports.distance200EOffsetY =
  exports.distance200EOffsetX =
  exports.distance200EColor =
  exports.distance200EBlurRadius =
  exports.distance200DSpreadRadius =
  exports.distance200DOffsetY =
  exports.distance200DOffsetX =
  exports.distance200DColor =
  exports.distance200DBlurRadius =
  exports.distance200CSpreadRadius =
  exports.distance200COffsetY =
  exports.distance200COffsetX =
  exports.distance200CColor =
  exports.distance200CBlurRadius =
  exports.distance200BSpreadRadius =
  exports.distance200BOffsetY =
  exports.distance200BOffsetX =
  exports.distance200BColor =
  exports.distance200BBlurRadius =
  exports.distance200ASpreadRadius =
  exports.distance200AOffsetY =
  exports.distance200AOffsetX =
  exports.distance200AColor =
  exports.distance200ABlurRadius =
  exports.distance100DSpreadRadius =
  exports.distance100DOffsetY =
  exports.distance100DOffsetX =
  exports.distance100DColor =
  exports.distance100DBlurRadius =
  exports.distance100CSpreadRadius =
  exports.distance100COffsetY =
  exports.distance100COffsetX =
  exports.distance100CColor =
  exports.distance100CBlurRadius =
  exports.distance100BSpreadRadius =
  exports.distance100BOffsetY =
  exports.distance100BOffsetX =
  exports.distance100BColor =
  exports.distance100BBlurRadius =
  exports.distance100ASpreadRadius =
  exports.distance100AOffsetY =
  exports.distance100AOffsetX =
  exports.distance100AColor =
  exports.distance100ABlurRadius =
  exports.defaultSpreadRadius =
  exports.defaultOffsetY =
  exports.defaultOffsetX =
  exports.defaultColor =
  exports.defaultBlurRadius =
  exports.colorNeutral =
    void 0;
/**
 * This is a generated file. Do not edit directly
 */

const colorNeutral = '#000000';
exports.colorNeutral = colorNeutral;
const distance100AOffsetX = '0px';
exports.distance100AOffsetX = distance100AOffsetX;
const distance100AOffsetY = '0.4px';
exports.distance100AOffsetY = distance100AOffsetY;
const distance100ABlurRadius = '0.5px';
exports.distance100ABlurRadius = distance100ABlurRadius;
const distance100ASpreadRadius = '0px';
exports.distance100ASpreadRadius = distance100ASpreadRadius;
const distance100AColor = 'rgba(0,0,0,0.1)';
exports.distance100AColor = distance100AColor;
const distance100BOffsetX = '0px';
exports.distance100BOffsetX = distance100BOffsetX;
const distance100BOffsetY = '0.6px';
exports.distance100BOffsetY = distance100BOffsetY;
const distance100BBlurRadius = '0.7px';
exports.distance100BBlurRadius = distance100BBlurRadius;
const distance100BSpreadRadius = '-1.2px';
exports.distance100BSpreadRadius = distance100BSpreadRadius;
const distance100BColor = 'rgba(0,0,0,0.1)';
exports.distance100BColor = distance100BColor;
const distance100COffsetX = '0px';
exports.distance100COffsetX = distance100COffsetX;
const distance100COffsetY = '1.4px';
exports.distance100COffsetY = distance100COffsetY;
const distance100CBlurRadius = '1.6px';
exports.distance100CBlurRadius = distance100CBlurRadius;
const distance100CSpreadRadius = '-2.5px';
exports.distance100CSpreadRadius = distance100CSpreadRadius;
const distance100CColor = 'rgba(0,0,0,0.1)';
exports.distance100CColor = distance100CColor;
const distance100DOffsetX = '0px';
exports.distance100DOffsetX = distance100DOffsetX;
const distance100DOffsetY = '0px';
exports.distance100DOffsetY = distance100DOffsetY;
const distance100DBlurRadius = '2.8px';
exports.distance100DBlurRadius = distance100DBlurRadius;
const distance100DSpreadRadius = '-1.2px';
exports.distance100DSpreadRadius = distance100DSpreadRadius;
const distance100DColor = 'rgba(0,0,0,0.1)';
exports.distance100DColor = distance100DColor;
const distance200AOffsetX = '0px';
exports.distance200AOffsetX = distance200AOffsetX;
const distance200AOffsetY = '0.1px';
exports.distance200AOffsetY = distance200AOffsetY;
const distance200ABlurRadius = '0.1px';
exports.distance200ABlurRadius = distance200ABlurRadius;
const distance200ASpreadRadius = '0px';
exports.distance200ASpreadRadius = distance200ASpreadRadius;
const distance200AColor = 'rgba(0,0,0,0.1)';
exports.distance200AColor = distance200AColor;
const distance200BOffsetX = '0px';
exports.distance200BOffsetX = distance200BOffsetX;
const distance200BOffsetY = '0.4px';
exports.distance200BOffsetY = distance200BOffsetY;
const distance200BBlurRadius = '0.5px';
exports.distance200BBlurRadius = distance200BBlurRadius;
const distance200BSpreadRadius = '-0.7px';
exports.distance200BSpreadRadius = distance200BSpreadRadius;
const distance200BColor = 'rgba(0,0,0,0.1)';
exports.distance200BColor = distance200BColor;
const distance200COffsetX = '0px';
exports.distance200COffsetX = distance200COffsetX;
const distance200COffsetY = '1.1px';
exports.distance200COffsetY = distance200COffsetY;
const distance200CBlurRadius = '1.2px';
exports.distance200CBlurRadius = distance200CBlurRadius;
const distance200CSpreadRadius = '-1.5px';
exports.distance200CSpreadRadius = distance200CSpreadRadius;
const distance200CColor = 'rgba(0,0,0,0.1)';
exports.distance200CColor = distance200CColor;
const distance200DOffsetX = '0px';
exports.distance200DOffsetX = distance200DOffsetX;
const distance200DOffsetY = '2.7px';
exports.distance200DOffsetY = distance200DOffsetY;
const distance200DBlurRadius = '3.2px';
exports.distance200DBlurRadius = distance200DBlurRadius;
const distance200DSpreadRadius = '-2px';
exports.distance200DSpreadRadius = distance200DSpreadRadius;
const distance200DColor = 'rgba(0,0,0,0.1)';
exports.distance200DColor = distance200DColor;
const distance200EOffsetX = '0px';
exports.distance200EOffsetX = distance200EOffsetX;
const distance200EOffsetY = '-0.1px';
exports.distance200EOffsetY = distance200EOffsetY;
const distance200EBlurRadius = '1.2px';
exports.distance200EBlurRadius = distance200EBlurRadius;
const distance200ESpreadRadius = '0px';
exports.distance200ESpreadRadius = distance200ESpreadRadius;
const distance200EColor = 'rgba(0,0,0,0.1)';
exports.distance200EColor = distance200EColor;
const distance200FOffsetX = '0px';
exports.distance200FOffsetX = distance200FOffsetX;
const distance200FOffsetY = '0px';
exports.distance200FOffsetY = distance200FOffsetY;
const distance200FBlurRadius = '3.5px';
exports.distance200FBlurRadius = distance200FBlurRadius;
const distance200FSpreadRadius = '-2.2px';
exports.distance200FSpreadRadius = distance200FSpreadRadius;
const distance200FColor = 'rgba(0,0,0,0.2)';
exports.distance200FColor = distance200FColor;
const distance300AOffsetX = '0px';
exports.distance300AOffsetX = distance300AOffsetX;
const distance300AOffsetY = '0.4px';
exports.distance300AOffsetY = distance300AOffsetY;
const distance300ABlurRadius = '0.5px';
exports.distance300ABlurRadius = distance300ABlurRadius;
const distance300ASpreadRadius = '0px';
exports.distance300ASpreadRadius = distance300ASpreadRadius;
const distance300AColor = 'rgba(0,0,0,0.025)';
exports.distance300AColor = distance300AColor;
const distance300BOffsetX = '0px';
exports.distance300BOffsetX = distance300BOffsetX;
const distance300BOffsetY = '1.2px';
exports.distance300BOffsetY = distance300BOffsetY;
const distance300BBlurRadius = '1.3px';
exports.distance300BBlurRadius = distance300BBlurRadius;
const distance300BSpreadRadius = '-0.8px';
exports.distance300BSpreadRadius = distance300BSpreadRadius;
const distance300BColor = 'rgba(0,0,0,0.025)';
exports.distance300BColor = distance300BColor;
const distance300COffsetX = '0px';
exports.distance300COffsetX = distance300COffsetX;
const distance300COffsetY = '2.9px';
exports.distance300COffsetY = distance300COffsetY;
const distance300CBlurRadius = '3.3px';
exports.distance300CBlurRadius = distance300CBlurRadius;
const distance300CSpreadRadius = '-1.7px';
exports.distance300CSpreadRadius = distance300CSpreadRadius;
const distance300CColor = 'rgba(0,0,0,0.025)';
exports.distance300CColor = distance300CColor;
const distance300DOffsetX = '0.1px';
exports.distance300DOffsetX = distance300DOffsetX;
const distance300DOffsetY = '6.9px';
exports.distance300DOffsetY = distance300DOffsetY;
const distance300DBlurRadius = '7.8px';
exports.distance300DBlurRadius = distance300DBlurRadius;
const distance300DSpreadRadius = '-2.5px';
exports.distance300DSpreadRadius = distance300DSpreadRadius;
const distance300DColor = 'rgba(0,0,0,0.025)';
exports.distance300DColor = distance300DColor;
const distance300EOffsetX = '0px';
exports.distance300EOffsetX = distance300EOffsetX;
const distance300EOffsetY = '0px';
exports.distance300EOffsetY = distance300EOffsetY;
const distance300EBlurRadius = '7.8px';
exports.distance300EBlurRadius = distance300EBlurRadius;
const distance300ESpreadRadius = '-2.5px';
exports.distance300ESpreadRadius = distance300ESpreadRadius;
const distance300EColor = 'rgba(0,0,0,0.1)';
exports.distance300EColor = distance300EColor;
const defaultOffsetX = '0px';
exports.defaultOffsetX = defaultOffsetX;
const defaultOffsetY = '15px';
exports.defaultOffsetY = defaultOffsetY;
const defaultBlurRadius = '44px';
exports.defaultBlurRadius = defaultBlurRadius;
const defaultSpreadRadius = '0px';
exports.defaultSpreadRadius = defaultSpreadRadius;
const defaultColor = 'rgba(0,0,0,0.1)';
exports.defaultColor = defaultColor;
